import ProductDescription from './ProductDescription'

const RFIInfantFruitsAndVegsProduct = {
  ...ProductDescription,
  category: '12',
  subCategory: '001RFI',
  IsBroadband: true,
  ProductType: 'Fruit',
  PackageType: '',
  Size: '4 ounces only',
  MultiPackageType: false,
  MultiPackageCount: null,
  Organic: false,
  NoAdditionalIngredients: false,
}

export default RFIInfantFruitsAndVegsProduct
